import firebase from 'firebase';
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore';

export const usePost = postId => {
    const [value, loading] = useDocumentDataOnce(firebase.firestore().doc(`posts/${postId}`));

    return {
        post: value,
        isLoading: loading,
    };
};
